export enum SecurityGroupImportFrom {
    TrustedDomain = 'TrustedDomain',
    ActiveDomain = 'ActiveDomain',
    Catalog = 'Catalog',
    Scim = 'Scim'
}
